export default {"src":"/_next/static/media/copy.b1c7f36b.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};